import { useEffect } from "react";
import { useToasterStore } from "react-hot-toast";

import { BOTTOM_RIGHT_TOASTER_ID } from "../alerts/constants";
import { noteBottomRightToastSnapshot } from "./bottomRightToastStack";

/** Frees a stack slot when the host closes a toast on its own (timeout), without repeating that toast's dismiss. */
export function BottomRightToastLimit() {
  const { toasts } = useToasterStore(undefined, BOTTOM_RIGHT_TOASTER_ID);

  useEffect(() => {
    noteBottomRightToastSnapshot(toasts);
  }, [toasts]);

  return null;
}
